import { render } from "./ZoomComponent.vue?vue&type=template&id=0a60420b&scoped=true"
import script from "./ZoomComponent.vue?vue&type=script&lang=js"
export * from "./ZoomComponent.vue?vue&type=script&lang=js"

import "./ZoomComponent.vue?vue&type=style&index=0&id=0a60420b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a60420b"]])

export default __exports__